import React, { useState } from 'react';
import { Flex, Spacer, View } from 'vcc-ui';
import DocsNavigation from '../components/docs-navigation';
import { Footer } from '../components/footer';
import { Topbar } from '../components/topbar';

interface PageLayoutProps {
  children: React.ReactNode;
  extra?: React.ReactNode;
  currentTheme: 'dark' | 'light';
  setCurrentTheme(theme: 'dark' | 'light'): void;
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  extra,
  currentTheme,
  setCurrentTheme,
}) => {
  const [mobileNavIsOpen, setMobileNavIsOpen] = useState(false);
  return (
    <View backgroundColor="background.primary">
      <Topbar
        onMobileNavClick={() => setMobileNavIsOpen((isOpen) => !isOpen)}
        mobileNavIsOpen={mobileNavIsOpen}
      />
      <View extend={pageLayoutCSS}>
        <DocsNavigation
          setCurrentTheme={setCurrentTheme}
          currentTheme={currentTheme}
          mobileNavIsOpen={mobileNavIsOpen}
        />
        <Flex extend={{ maxWidth: '100%', overflow: 'auto' }}>
          {children}
          <Spacer size={4} />
          <Footer />
        </Flex>
        {extra}
      </View>
    </View>
  );
};

const pageLayoutCSS = {
  display: 'grid',
  alignSelf: 'center',
  width: 'var(--content-width)',
  gridTemplateColumns: 'var(--grid-columns)',
  columnGap: 'var(--grid-column-gap)',
  overflowWrap: 'anywhere' as any,
  wordBreak: 'break-word' as any,
  untilL: {
    justifyContent: 'center',
  },
};
